import { __module as t } from "../../../_virtual/isDate.js";
import { m as r } from "./util/merge.js";
!function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (t, r) {
    if (r = "string" == typeof r ? (0, n.default)({
      format: r
    }, a) : (0, n.default)(r, a), "string" == typeof t && (e = r.format, /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(e))) {
      var e,
        i,
        u = r.delimiters.find(function (t) {
          return -1 !== r.format.indexOf(t);
        }),
        f = r.strictMode ? u : r.delimiters.find(function (r) {
          return -1 !== t.indexOf(r);
        }),
        l = function (t, r) {
          for (var e = [], n = Math.min(t.length, r.length), o = 0; o < n; o++) e.push([t[o], r[o]]);
          return e;
        }(t.split(f), r.format.toLowerCase().split(u)),
        c = {},
        s = function (t, r) {
          if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
            if (Array.isArray(t) || (i = o(t))) {
              i && (t = i);
              var e = 0,
                n = function n() {};
              return {
                s: n,
                n: function n() {
                  return e >= t.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: t[e++]
                  };
                },
                e: function e(t) {
                  throw t;
                },
                f: n
              };
            }
            throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          var i,
            a,
            u = !0,
            _f = !1;
          return {
            s: function s() {
              i = t[Symbol.iterator]();
            },
            n: function n() {
              var t = i.next();
              return u = t.done, t;
            },
            e: function e(t) {
              _f = !0, a = t;
            },
            f: function f() {
              try {
                u || null == i.return || i.return();
              } finally {
                if (_f) throw a;
              }
            }
          };
        }(l);
      try {
        for (s.s(); !(i = s.n()).done;) {
          var d,
            y = (d = i.value, function (t) {
              if (Array.isArray(t)) return t;
            }(d) || function (t, r) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
                var e = [],
                  n = !0,
                  o = !1,
                  i = void 0;
                try {
                  for (var a, u = t[Symbol.iterator](); !(n = (a = u.next()).done) && (e.push(a.value), !r || e.length !== r); n = !0);
                } catch (t) {
                  o = !0, i = t;
                } finally {
                  try {
                    n || null == u.return || u.return();
                  } finally {
                    if (o) throw i;
                  }
                }
                return e;
              }
            }(d, 2) || o(d, 2) || function () {
              throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }()),
            m = y[0],
            p = y[1];
          if (m.length !== p.length) return !1;
          c[p.charAt(0)] = m;
        }
      } catch (t) {
        s.e(t);
      } finally {
        s.f();
      }
      return new Date("".concat(c.m, "/").concat(c.d, "/").concat(c.y)).getDate() === +c.d;
    }
    return !r.strictMode && "[object Date]" === Object.prototype.toString.call(t) && isFinite(t);
  };
  var n = r && r.__esModule ? r : {
    default: r
  };
  function o(t, r) {
    if (t) {
      if ("string" == typeof t) return i(t, r);
      var e = Object.prototype.toString.call(t).slice(8, -1);
      if ("Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e) return Array.from(t);
      if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return i(t, r);
    }
  }
  function i(t, r) {
    (null == r || r > t.length) && (r = t.length);
    for (var e = 0, n = Array(r); e < r; e++) n[e] = t[e];
    return n;
  }
  var a = {
    format: "YYYY/MM/DD",
    delimiters: ["/", "-"],
    strictMode: !1
  };
  t.exports = e.default, t.exports.default = e.default;
}(t, t.exports);
var e = t.exports;
export { e as i };